import get from 'lodash/get';

interface AppWindow extends Window {
  AppConfig: Record<string, unknown>;
}

const config = (path: string): unknown =>
  get((window as AppWindow & typeof globalThis).AppConfig, path);

export default config;
